const checkoutStoreUrl = 'http://localhost:8000';

function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

document.addEventListener('DOMContentLoaded', async function () {
    try {
        let sessionId = localStorage.getItem('shopify_custom_session_id');
        if(!localStorage.getItem('shopify_custom_session_id')) {
            const domain = window.location.hostname;
            if(domain.includes("shopifypreview.com")) {
              return;
            }
            sessionId = generateUUID();
            const ipInfoResponse = await fetch('https://ipapi.co/json/');
            const ipData = await ipInfoResponse.json();
            const response = await fetch(`${checkoutStoreUrl}/api/save-session`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ domain, sessionId, ip: ipData })
            });
            const data = await response.json();
            if(data.status === 'ok') {
                localStorage.setItem('shopify_custom_session_id', sessionId);
            }
        }
    } catch (error) {
        console.error('Error saving store domain:', error);
    }
});

document.addEventListener('DOMContentLoaded', function () {

    const addToCartBtn = document.querySelector('.product-form__buttons > button[name="add"]');
    if (!addToCartBtn) return;

    addToCartBtn.style.display = "block";

    addToCartBtn.addEventListener('click', async (e) => {
      	e.preventDefault();

        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = "Wait...";

        let sessionId = localStorage.getItem('shopify_custom_session_id');
        if (!sessionId) {
            console.warn("Session ID not found.");
            return;
        }

        const storeDomain = window.location.hostname;
        const variantId = document.querySelector('input[name="id"]').value;
        const response = await fetch(`/variants/${variantId}.js`);
        const variant = await response.json();
        const quantityInput = document.querySelector(".price-per-item__container quantity-input.quantity input.quantity__input");

        try {
            const response = await fetch(`${checkoutStoreUrl}/api/bank-account/add-to-cart`, {
              method: 'POST',
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                  store_domain: storeDomain,
                  session_id: sessionId,
                  variant_sku: variant.sku,
                  quantity: quantityInput.value
              })
            });
            const data = await response.json();
            console.log('Response from Laravel:', data);
        } catch (error) {
            console.error('Error sending request:', error);
        } finally {
            addToCartBtn.disabled = false;
            addToCartBtn.innerHTML = "Add To Cart";
        }
        e.target.form.submit();
    });
});

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.quantity.cart-quantity button[name="minus"]').forEach(el => {
    el.style.display = "block";
  });
  document.querySelectorAll('.quantity.cart-quantity button[name="plus"]').forEach(el => {
    el.style.display = "block";
  });
  document.querySelectorAll('cart-remove-button a').forEach(el => {
    el.style.display = "inline-flex";
  });

  document.addEventListener("click", async function(event) {

    const storeDomain = window.location.hostname;
    const minusBtn = event.target.closest('.quantity.cart-quantity button[name="minus"]');
    const plusBtn = event.target.closest('.quantity.cart-quantity button[name="plus"]');
    const removeBtn = event.target.closest('cart-remove-button a');
    const quantityInput = event.target.closest('.quantity.cart-quantity')?.querySelector('.quantity__input');

    if(quantityInput) {
      quantityInput.addEventListener('change', async function(e) {

        const variantId = e.target.getAttribute("data-quantity-variant-id");

        const sessionId = localStorage.getItem('shopify_custom_session_id');
        if (!sessionId) {
          console.warn("Session ID not found.");
          return;
        }

        const response = await fetch(`/variants/${variantId}.js`)
        const variant = await response.json();

        try {
          const response = await fetch(`${checkoutStoreUrl}/api/bank-account/update-cart-item-quantity`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              store_domain: storeDomain,
              session_id: sessionId,
              variant_sku: variant.sku,
              quantity: e.target.value
            })
          });
          const data = await response.json();
          console.log("Quantity synced to the server:", data);
        } catch (error) {
          console.error("Error syncing quantity:", error);
        } finally {
          document.querySelectorAll('.quantity.cart-quantity button[name="minus"]').forEach(el => {
            el.style.display = "block";
          });
          document.querySelectorAll('.quantity.cart-quantity button[name="plus"]').forEach(el => {
            el.style.display = "block";
          });
          document.querySelectorAll('cart-remove-button a').forEach(el => {
            el.style.display = "inline-flex";
          });
        }

        return; 
      });
    }

    if (minusBtn || plusBtn) {
      const btn = minusBtn || plusBtn;
      const input = btn.closest('.quantity.cart-quantity').querySelector('.quantity__input');

      if (!input) return;

      const variantId = input.getAttribute("data-quantity-variant-id");
      const quantity = parseInt(input.value);
      const sessionId = localStorage.getItem('shopify_custom_session_id');
      if (!sessionId) {
        console.warn("Session ID not found.");
        return;
      }

      const response = await fetch(`/variants/${variantId}.js`)
      const variant = await response.json();

      try {
        const response = await fetch(`${checkoutStoreUrl}/api/bank-account/update-cart-item-quantity`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            store_domain: storeDomain,
            session_id: sessionId,
            variant_sku: variant.sku,
            quantity: quantity
          })
        });
        const data = await response.json();
        console.log("Quantity synced to the server:", data);
      } catch (error) {
        console.error("Error syncing quantity:", error);
      } finally {
        document.querySelectorAll('.quantity.cart-quantity button[name="minus"]').forEach(el => {
          el.style.display = "block";
        });
        document.querySelectorAll('.quantity.cart-quantity button[name="plus"]').forEach(el => {
          el.style.display = "block";
        });
        document.querySelectorAll('cart-remove-button a').forEach(el => {
          el.style.display = "inline-flex";
        });
      }

      return;
    }

    if (removeBtn) {

      const cartItem = removeBtn.closest('tr');
      const input = cartItem.querySelector('.quantity__input');
      const variantId = input?.getAttribute('data-quantity-variant-id');
      const sessionId = localStorage.getItem('shopify_custom_session_id');

      if (!variantId || !sessionId) {
        console.warn("Missing variant ID or session ID for removal.");
        return;
      }

      const response = await fetch(`/variants/${variantId}.js`)
      const variant = await response.json();

      try {
        const response = await fetch(`${checkoutStoreUrl}/api/bank-account/remove-cart-item`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            store_domain: storeDomain,
            session_id: sessionId,
            variant_sku: variant.sku
          })
        });

        const data = await response.json();
        console.log("Item removed from server-side cart:", data);

      } catch (error) {
        console.error("Failed to remove cart item:", error);
      } finally {
        document.querySelectorAll('.quantity.cart-quantity button[name="minus"]').forEach(el => {
          el.style.display = "block";
        });
        document.querySelectorAll('.quantity.cart-quantity button[name="plus"]').forEach(el => {
          el.style.display = "block";
        });
        document.querySelectorAll('cart-remove-button a').forEach(el => {
          el.style.display = "inline-flex";
        });
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {

    const storeDomain = window.location.hostname;
    const checkoutBtn = document.getElementById("checkout");
    if(!checkoutBtn) return;

    checkoutBtn.style.display = "block";

    checkoutBtn.addEventListener('click', function (event) {
        event.preventDefault();

        checkoutBtn.disabled = true;
        checkoutBtn.innerHTML = "Wait...";

        const sessionId = localStorage.getItem('shopify_custom_session_id');

        fetch(`${checkoutStoreUrl}/api/bank-account/get-checkout-url`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                store_domain: storeDomain,
                session_id: sessionId
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'ok') {
                window.location.href = data.checkout_url;
            } else if (data.status === 'disabled') {
                window.location.href = "/checkout";
            } else if(data.status === 'expired') {
                localStorage.removeItem('shopify_custom_session_id');
            }
        })
        .catch(error => {
            console.log(error.message);
            window.location.href = "/checkout";
        }).finally(() => {
            checkoutBtn.disabled = false;
            checkoutBtn.innerHTML = "Checkout";
        });
    });
});
